import { Box, styled, Typography } from "@mui/material";
import React from "react";
import { primary } from "../../../constants/theme";
const CustomContent = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "82%",
  margin: "20px auto",
  ".list-container": {
    padding: "2px",
    marginTop: "16px",
  },
  ".listItem": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    marginBottom: "30px",
  },
  ".listIcon": {
    background: primary?.lightPink,
    minWidth: "50px",
    minHeight: "50px",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ".listItem-heading": {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "4px",
  },
  ".listItem-description": {
    fontSize: "16px",
    fontWeight: "400",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "0 12px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "0 12px",
    ".listItem-description": {
      fontSize: "12px",
    },
    ".listIcon": {
      background: primary?.lightPink,
      minWidth: "40px",
      minHeight: "30px",
      borderRadius: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
}));
const VehiclesAdv = ({ listItems = null }) => {
  return (
    <CustomContent>
      <Box className="list-container">
        {listItems?.map((item, index) => (
          <Box key={index} className="listItem">
            <Box className="listIcon" style={{ color: primary.main }}>
              {item?.icon}
            </Box>
            <Box>
              <Typography className="listItem-heading" variant="h5">
                {item?.heading}
              </Typography>
              <Typography className="listItem-description">
                {item?.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </CustomContent>
  );
};
export default VehiclesAdv;
